module.exports = __webpack_public_path__ + "img/zh.bae6497c.png";